import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-project-image-carousel',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './project-image-carousel.component.html',
  styleUrl: './project-image-carousel.component.sass'
})
export class ProjectImageCarouselComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) images!: string[];
  @Input() alt = '';

  index = 0;
  /** When true, the auto-advance timer is stopped until toggled again. */
  paused = false;
  private timerId: ReturnType<typeof setInterval> | undefined;
  private readonly intervalMs = 5000;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['images']) {
      this.index = 0;
      this.paused = false;
      this.restartTimer();
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  private restartTimer(): void {
    this.clearTimer();
    if (!this.images || this.images.length <= 1 || this.paused) {
      return;
    }
    this.timerId = setInterval(() => {
      this.next();
    }, this.intervalMs);
  }

  togglePlayback(): void {
    if (!this.images || this.images.length <= 1) {
      return;
    }
    this.paused = !this.paused;
    if (this.paused) {
      this.clearTimer();
    } else {
      this.restartTimer();
    }
  }

  onSlideKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    if (event.key === ' ') {
      event.preventDefault();
    }
    this.togglePlayback();
  }

  private clearTimer(): void {
    if (this.timerId !== undefined) {
      clearInterval(this.timerId);
      this.timerId = undefined;
    }
  }

  next(): void {
    if (!this.images?.length) {
      return;
    }
    this.index = (this.index + 1) % this.images.length;
  }

  prev(): void {
    if (!this.images?.length) {
      return;
    }
    this.index = (this.index - 1 + this.images.length) % this.images.length;
  }

  goTo(i: number): void {
    if (i >= 0 && i < this.images.length) {
      this.index = i;
    }
  }
}
